module.exports = __webpack_public_path__ + "img/xuanxing_banner_en.c974f5bf.jpg";